// export const API_URL = "http://localhost:8030/api";
//export const API_URL = "http://dev.marshrutki.weeteam.net/api";
export const API_URL = "/api";
export const LOCIZE_PID = "1639b5ef-6cfd-4ed9-89da-a62903d06ff5"